import apiService from "./api.service";


class CompanyService {
    async get(entry = "") {
        console.log(`Getting company with entry ${entry}`);
        const result = apiService.post('/kong/api/v1/company/globalsearch/', "", { headers: { 'X-Search': entry }})
        .then(function (response) {

          const company = [];

          var reslen = response.data.Result.length
          for (var i = 0; i < reslen; i++) {

            var row = {
              id: response.data.Result[i].id,
              company: response.data.Result[i].company,
              address: response.data.Result[i].address,
              postal: response.data.Result[i].postal,
              city: response.data.Result[i].city,
              province: response.data.Result[i].province,
              country: response.data.Result[i].country,
              division: response.data.Result[i].division,
              display: response.data.Result[i].company,
              addressCoordinates: response.data.Result[i].addressCoordinates,
              ...response.data.Result[i]
            };

            if (row.division != null && row.division.length > 0) row.display += " - " + row.division;
            if (row.city != null) row.display += ", " + row.city;

            company.push(row)
          }

          return company;

        })
        .catch(function (error) {

          console.log('get company error: ' + JSON.stringify(error));
        });

        return result;
    }
}

export default new CompanyService();


// WEBPACK FOOTER //
// ./src/services/company.service.js